
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/lumpsum",
      function () {
        return require("private-next-pages/calculators/lumpsum/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/lumpsum"])
      });
    }
  